import clsx from "clsx";
import { HomeProducts, HomeBanners } from "../components";
import { Layout } from "../layouts";
import { useLayout } from "../context";

const HomePage = () => {

  const {isSidebarCollapsed} = useLayout();

  return (
    <Layout
      className="home"
      header={true}
      showCartIcon={true}
      rightSidebar={false}
      hideRightSidebarOnMobile={false}
    >
      <div className="home-shell">
        <div className={clsx("home-body-grid", !isSidebarCollapsed && 'home-toggle-space')}>
          <div className="home-main-column">
            <HomeBanners />
            <HomeProducts />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
